import React from 'react'

interface DividerProps {
  className?: string
}

const Divider: React.FC<DividerProps> = ({ className = '' }) => {
  return (
    <div className={`w-full h-1px ${className}`}>
      <div className="w-full h-full bg-divider-divider-1"></div>
    </div>
  )
}

export default Divider
